import quickview from "./quickview.component";

const quickviewModule = angular
  .module("app.components.quickview", [])
  .component("quickview", quickview);

export default quickviewModule;



// WEBPACK FOOTER //
// ./src/components/quickview/quickview.module.js